import { getBridgeSdk } from "@swiggy-private/checkout-core";
import { OOPS_SOMETHING_WENT_WRONG } from "@payment-client/constants/TextDict";
import { BackAlert } from "@swiggy-private/native-bridge";

interface NativeAlertArgs {
    message?: string;
    title?: string;
    buttonName?: string;
}

export const showNativeAlert = async ({
    message = OOPS_SOMETHING_WENT_WRONG,
    title = " ",
    buttonName = "Ok",
}: NativeAlertArgs = {}): Promise<void> => {
    getBridgeSdk()
        .alert({
            message,
            title,
            buttonName,
        })
        .catch(() => void 0);
};

export const showNativeHeader = async ({
    title = "",
    backURL,
    backAlert,
}: {
    title?: string;
    backURL: string;
    backAlert?: BackAlert;
}): Promise<void> => {
    getBridgeSdk()
        .showHeader({ show: true, title, backURL, backAlert })
        .catch(() => void 0);
};

export const hideNativeHeader = (): void => {
    getBridgeSdk()
        .showHeader({ show: false, title: "" })
        .catch(() => void 0);
};
